var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHourGlassLoading = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99961 1.33203C5.24427 1.33203 3.86627 1.33203 3.46494 2.1987C3.43045 2.27336 3.40148 2.35046 3.37827 2.42936C3.10494 3.35403 4.07961 4.42603 6.02761 6.56936L7.33294 7.9987H8.66627L9.97161 6.57003C11.9196 4.42603 12.8936 3.35403 12.6209 2.43003C12.5978 2.35066 12.5689 2.27311 12.5343 2.19803C12.1329 1.33203 10.7549 1.33203 7.99961 1.33203Z",
    fill: "#5D5CF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.46574 13.8C3.86708 14.6667 5.24508 14.6667 8.00041 14.6667C10.7557 14.6667 12.1337 14.6667 12.5351 13.8C12.5696 13.7253 12.5986 13.6482 12.6217 13.5693C12.8951 12.6447 11.9204 11.5727 9.97241 9.42933L8.66708 8H7.33374L6.02841 9.42867C4.08041 11.5727 3.10641 12.6447 3.37908 13.5687C3.40241 13.6487 3.43108 13.7253 3.46574 13.8Z",
    fill: "#5D5CF5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHourGlassLoading, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hour-glass-loading.cf4abf61.svg";
export { ForwardRef as ReactComponent };